import * as React from 'react'

type IntrinsicInputProps = JSX.IntrinsicElements['input']

interface ImageInputProps {
  onChange: (base64: string) => void
}

type Props =
  IntrinsicInputProps
  & ImageInputProps

class ImageInput extends React.Component<Props> {
  private reader: FileReader

  public constructor (props) {
    super(props)

    this.reader = new FileReader()
    this.reader.onloadend = this.handleConversionEnd
  }

  public render () {
    return (
      <input
        {...this.props}
        onChange={this.handleChange}
      />
    )
  }

  private handleChange = e => {
    /* convert to base64 */
    this.reader.readAsDataURL(e.target.files[ 0 ])

    /*
     we're removing state from the DOM by resetting the input element's value to null
     on any change, otherwise it won't trigger an onChange event in case of the same
     file being uploaded twice (which we need in case the user deletes his file but
     then uploads the same file again, if we didn't do that it would be kept in the
     DOM's input state but be missing in our data model which wouldn't be updated
     the next time the user uploads the same file as the one in the DOM state)
     */
    e.target.value = null
  }

  private handleConversionEnd = () => {
    /*
     onloadend handler for the file-reader, called when it's done converting to base64
     -> this.reader.result is a base64 string of the image-file
     */
    this.props.onChange(this.reader.result as string)
  }
}

export default ImageInput



// WEBPACK FOOTER //
// ./src/components/atoms/ImageInput.tsx